export default __webpack_public_path__ + "static/media/html-and-CSS.8ee8bc43.jpg";